export namespace Message {
  export const INPUT_REQUIRED = 'Field is required';
  export const SESSION_EXPIRATION =
    'You‘ve been logged out because of inactivity.';
}
